import styled from 'styled-components';
import {dFlexColumn} from '../../../../../globalVariables/GlobalFlex';
import {LIGHT_GRAY} from '../../../../../globalVariables/GlobalVariables';

export const wideCardsMedia = '@media screen and (max-width: 1722px)';

const darkTokens = `
  --TA-color-bg-base: rgba(255, 255, 255, 0.08);
  --TA-color-bg-surface-default: rgba(255, 255, 255, 0.12);
  --TA-color-bg-surface-hover: rgba(255, 255, 255, 0.18);
  --TA-color-border-subtle: rgba(255, 255, 255, 0.2);
  --TA-color-text-default: ${LIGHT_GRAY};
  --TA-color-text-subtle: rgba(248, 247, 247, 0.7);
  --TA-color-text-disabled: rgba(248, 247, 247, 0.4);
`;

const darkDayPopup = `
  [data-cy="timetableDayPopup"],
  [data-cy="timetableDayPopup-footer"],
  [data-cy^="timetableDayPopup-items-layer"] {
    background: var(--primitive-gray-700);
  }
  [data-cy="timetableDayPopup-footer"] {
    border-top-color: rgba(255, 255, 255, 0.15);
  }
  [data-cy="timetableDayPopup"] {
    --color-border-subtle: rgba(255, 255, 255, 0.15);
    --color-brand-selected: rgba(255, 255, 255, 0.08);
  }
`;

export const container = styled.div`
  ${dFlexColumn}
  gap: var(--space-lg);
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  ${p => p.theme.isDarkMode && darkTokens}
  ${p => p.theme.isDarkMode && darkDayPopup }
`;

export const dot = styled.span<{$c: string}>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${p => p.$c};
  flex-shrink: 0;
`;
